import { NG_VALIDATORS, Validator, NgModel, AbstractControl } from '@angular/forms';
import { Directive, OnChanges, Input } from '@angular/core';

@Directive({
  selector: '[appCountryValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CountryValidatorDirective, multi: true }],
})
export class CountryValidatorDirective implements OnChanges, Validator {
  @Input() countryList: any[];
  @Input() countryCodeKey: string;
  @Input() country?: NgModel;

  ngOnChanges() {
    if (this.country != undefined) {
      if (this.countryList && this.countryList.length > 0) {
        this.country.control.updateValueAndValidity();
      }
    }
  }

  validate(control: AbstractControl): any {
    if (this.countryList && this.countryList.length > 0 && control.value && control.value.trim() !== '') {
      const country = this.countryList.filter((country) => country[this.countryCodeKey].toLowerCase() === control.value.toLowerCase());
      return country && country.length == 0 ? { countryCode: true } : null;
    }
    return null;
  }
}
